export default __webpack_public_path__ + "static/3-c68744b716bb01efda922ac3606803d3.jpeg";